import debounce from 'debounce';
import { removeUpsell, setUpsellAmount } from './action';
import fetch from '../../../../js/api/fetch';
import { recalculatePrices } from '../Prices/action';
import { addError } from '../MetaData/action';
import changeProductAmount from '../../functions/changeProductAmount';
import { updateRootState } from '../../functions/updateRootState';
import updateMiniCart from '../../../../js/checkout/cart/binder/updateMiniCart';
import type { TypedDispatch, TypedMiddleware } from '../store';
import ErrorLogger from '../../../../js/error-logger/ErrorLogger';

const createBaseTracker = async () => import('@yoursurprise/segment-analytics').then((Segment) => new Segment.Tracker());

const debouncedSend = debounce(changeProductAmount, 500);

export const setUpsellAmountMiddleware: TypedMiddleware = (storeApi) => (next) => (action) => {
    if (setUpsellAmount.match(action)) {
        debouncedSend(storeApi.dispatch, Number(action.payload.id), action.payload.amount);

        const result = next(action);
        storeApi.dispatch(recalculatePrices());
        return result;
    }
    return next(action);
};

export const hasCartItemId = (json: unknown): json is { cartItemId: number } => {
    if (typeof json !== 'object' || json === null) {
        return false;
    }

    return Object.prototype.hasOwnProperty.call(json, 'cartItemId')
        && typeof (json as { cartItemId? : number })?.cartItemId === 'number';
};

const removeUpsellCall = async (dispatch:TypedDispatch, cartItemId:number): Promise<void> => {
    await fetch('upsell/remove', {
        body: JSON.stringify({ cartItemId }),
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        method: 'POST',
    });

    await updateRootState(dispatch);
};

export const removeUpsellMiddleware: TypedMiddleware = (storeApi) => (next) => (action) => {
    if (removeUpsell.match(action)) {
        removeUpsellCall(storeApi.dispatch, Number(action.payload.id))
            .then(() => {
                updateMiniCart();
                createBaseTracker().then((tracker) => {
                    tracker.track('Upsell Item Removed', {
                        label: String(action.payload.productId),
                        parentCartItemId: action.payload.parentCartItemId,
                        parentProductId: action.payload.parentProductId,
                        productId: action.payload.productId,
                        type: 'slider',
                    });
                }).catch((e: Error) => ErrorLogger.createFromGlobals()?.log(e));
            })
            .catch(() => storeApi.dispatch(addError()));

        const result = next(action);
        storeApi.dispatch(recalculatePrices());
        return result;
    }

    return next(action);
};
